import React from 'react';

export const NotFound: React.FC = () => {
  return (
    <div className={'container'}>
      <div style={{ textAlign: 'center' }}>
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you are looking for does not exist.</p>
      </div>
    </div>
  );
};
